import { styled } from '@mui/system'
import { TextField, Typography, Select, IconButton } from '@mui/material'

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '80%',
  marginTop: '2%',
  marginBottom: '6%',
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(1.5),
  },
}))

export const StyledListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}))

export const StyledSelect = styled(Select)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(1.5),
  },
}))

export const StyledHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.5rem',
  marginTop: '2%',
  marginBottom: '4%',
}))

export const StyledBadgeButton = styled(IconButton)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  backgroundColor: theme.palette.background.elevation9,
  border: '3px solid',
  borderColor: theme.palette.background.main,
  ':hover': {
    backgroundColor: theme.palette.background.elevation9,
  },
}))
